// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"d89bd0e6","787":"b7db63c6"}[chunkId] + ".chunk.js";
};